import * as h2Api from '../../h2Api'
import { browserHistory } from '../../util/browserHistory'
import { appendSearchResults, initSearchResults } from '../search'
import { ADD_OCCUPATION_LISTING } from '../occupations/occupations'

export const LOAD_IP_DATA = 'LOAD_IP_DATA'
export const ADVANCE_IP = 'ADVANCE_IP'
export const RESPOND_IP = 'IP_RESPOND_IP'
export const NEW_IP = 'NEW_IP'
export const CANCEL_NEW_IP = 'CANCEL_NEW_IP'
export const CONFIRM_OVERWRITE = 'CONFIRM_OVERWRITE'
export const CHOOSE_VERSION = 'CHOOSE_VERSION'
export const IP_RESULTS = 'IP_RESULTS'
export const ADD_IP_RESULTS = 'ADD_IP_RESULTS'
export const IP_SUMMARY = 'IP_SUMMARY'

export const fetchIPData = () => (dispatch, getState) => {
  const ip = getState().assessments.interestProfiler

  if (ip.questions) {
    return Promise.resolve(ip)
  }

  return dispatch(h2Api.get('/api/v1/assessment/ip/current')({ type: LOAD_IP_DATA }))
}

export const respond = (questionNum, questionId, response) => dispatch => {
  return dispatch(
    h2Api.post(`/api/v1/assessment/ip/short/respond/${questionId}`, {
      response
    })({ type: RESPOND_IP })
  )
}

export const beginNewProfiler = () => dispatch => {
  return Promise.resolve(dispatch({ type: NEW_IP }))
}

export const confirmOverwrite = () => dispatch => {
  return dispatch({ type: CONFIRM_OVERWRITE })
}

export const closeNewModal = () => dispatch => {
  return dispatch({ type: CANCEL_NEW_IP })
}

export const chooseVersion = v => dispatch => {
  return dispatch(h2Api.post(`/api/v1/assessment/ip/${v}/new`)({ type: CHOOSE_VERSION }))
}

export const moveToSummary = () => dispatch => {
  browserHistory.push(`/ip/short/summary`)
}
export const moveToPageViaHistory = page => {
  browserHistory.push(`/ip/short/questions/${page}`)
}

export const moveToPage = page => dispatch => {
  return Promise.resolve(dispatch({ type: ADVANCE_IP, pageId: page }))
}

export const loadIpSummary = () => {
  return h2Api.get(`/assessment/ip/short/summary`)({ type: IP_SUMMARY })
}

export const loadIpResults = filters => dispatch => {
  return dispatch(
    h2Api.post(`/assessment/ip/short/results`, { filters })({ type: IP_RESULTS })
  ).then(v => {
    dispatch(initSearchResults(v.results))

    return v
  })
}

export const loadSubsequentIpResults = filters => (startIdx, endIdx) => dispatch => {
  const updatedJson = {
    filters,
    start: startIdx,
    end: endIdx
  }

  return dispatch(
    h2Api.post(`/assessment/ip/short/results`, updatedJson)({ type: ADD_IP_RESULTS })
  ).then(v => {
    console.log('APPENDING')
    dispatch(appendSearchResults(v.results))
  })
}
